import image1 from '../images/gsin_211112_4876_0001.webp'
import image2 from '../images/ajohnson_210813_4713_0004.webp'
import image3 from '../images/dbohn_210820_4722_0002.webp'
import image4 from '../images/vpavic_210916_4760_0323.webp'
const latest = [
  { id: '1', image: image1, name: 'TCL 20S', price: '250', stars: '5', numberOfReviews: '19' },
  {
    id: '2',
    image: image2,
    name: 'Google Pixel 5A',
    price: '399',
    stars: '3',
    numberOfReviews: '3'
  },
  {
    id: '3',
    image: image3,
    name: 'Samsung Galaxy Z Fold 3 (256GB, unlocked)',
    price: '1400',
    stars: '2',
    numberOfReviews: '6'
  },
  {
    id: '4',
    image: image4,
    name: 'Apple iPhone 13 Mini',
    price: '729',
    stars: '4',
    numberOfReviews: '10'
  }
]
export default latest
